import Vue from "vue";
import directive from "@/directive";
Vue.use(directive);
